/**
 * Iter 67em (follow-up) — Global mount for the AI customer-support chat bubble.
 *
 * Surfaces the bubble on every PUBLIC page (homepage, browse, car-detail,
 * vendor micro-site, blog, location landing pages, booking success, contact,
 * legal) so a curious renter can ask a question at any step of the funnel.
 *
 * Hidden routes (where the bubble would be noise or the page is non-customer):
 *   • /embed/*          — iframe surfaces must stay clean
 *   • /dashboard/*      — operator views (admin / vendor / customer / partner / agent)
 *   • /login, /register, /forgot-password, /reset-password, /auth/callback
 *   • /agreements/*     — signed-doc viewer, intentionally distraction-free
 *   • /vendor/invoices/*— vendor editor
 *   • /widget-builder*  — vendor tooling
 *
 * When the user is on /cars/:id we forward the `carId` to the bubble so the
 * backend can route the WhatsApp handoff to the right vendor.
 */
import { useLocation, useMatch } from "react-router-dom";
import CustomerChatBubble from "./CustomerChatBubble";
import { useAuth } from "@/lib/auth";

const HIDE_PREFIXES = [
  "/embed/",
  "/dashboard/",
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
  "/auth/",
  "/agreements/",
  "/vendor/invoices/",
  "/widget-builder",
];

export default function GlobalChatBubble() {
  const { pathname } = useLocation();
  const carMatch = useMatch("/cars/:id");
  const { user } = useAuth() || {};

  // Hide on operator + embed + auth routes.
  for (const p of HIDE_PREFIXES) {
    if (pathname === p || pathname.startsWith(p)) return null;
  }

  const carId = carMatch?.params?.id || null;
  // Iter 68d — pass logged-in user so the lead-capture form auto-skips
  // (we already have their name/email/phone on the user record).
  const currentUser = user && user.role === "customer" ? user : null;
  // On the car-detail page a fixed bottom "Book" bar exists on mobile —
  // lift the bubble above it so the Book button stays fully tappable.
  return <CustomerChatBubble carId={carId} currentUser={currentUser} raised={!!carMatch} />;
}
